module.exports = __webpack_public_path__ + "img/11.7d60f01b.png";